import { render, staticRenderFns } from "./DaisoDialog.vue?vue&type=template&id=bc3bd836&"
import script from "./DaisoDialog.vue?vue&type=script&lang=js&"
export * from "./DaisoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports